var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccentStars01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 82,
    viewBox: "0 0 72 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accent_Stars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_20053_243278)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6203 45.366C35.2348 45.6268 35.9475 45.4169 36.3676 44.8818C37.6922 43.204 41.1914 38.9791 43.4522 38.1659C45.9393 37.2838 51.8248 38.3193 53.7489 38.6962C54.4517 38.8326 55.1785 38.4574 55.4473 37.7713C55.4489 37.7623 55.4534 37.7537 55.458 37.7452C55.6946 37.1218 55.475 36.4179 54.9688 36.0053C53.446 34.7731 49.1711 31.1561 48.4001 28.8257C47.54 26.2309 48.6813 20.0885 49.0826 18.1391C49.206 17.5423 48.9901 16.9199 48.5123 16.5683C48.3416 16.4418 48.1469 16.3484 47.947 16.2851C47.3771 16.1131 46.7597 16.3305 46.3746 16.8033C45.1309 18.3306 41.2004 22.983 38.7175 23.8751C36.4794 24.6799 31.3134 23.6346 29.2348 23.159C28.5567 23.002 27.855 23.3382 27.5311 23.9773C27.5165 24.0089 27.5024 24.0375 27.4877 24.0691C27.1918 24.7037 27.3603 25.4577 27.8743 25.912C29.4931 27.3353 33.5443 31.0745 34.3408 33.4311C35.1225 35.838 34.0453 41.3949 33.5839 43.514C33.4395 44.1786 33.7189 44.8682 34.2938 45.1996C34.4004 45.262 34.5116 45.3158 34.6267 45.364L34.6203 45.366Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_20053_243278)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8111 42.2108C21.9486 42.1077 21.9906 41.9128 21.9218 41.7447C21.7079 41.2099 21.1923 39.8193 21.2916 39.1889C21.4062 38.4974 22.384 37.2901 22.7125 36.9004C22.8309 36.7591 22.8386 36.5413 22.7163 36.3809C22.7163 36.3809 22.7163 36.377 22.7125 36.3732C22.6018 36.2319 22.4146 36.186 22.258 36.2433C21.7881 36.4229 20.4283 36.9004 19.8019 36.7553C19.1067 36.591 17.8576 35.4793 17.4642 35.1163C17.3458 35.0055 17.1777 34.9673 17.0364 35.0285C16.9867 35.0514 16.9409 35.0819 16.9027 35.1201C16.7919 35.2271 16.7652 35.399 16.8225 35.5518C17.0134 36.0485 17.5711 37.5958 17.4604 38.2872C17.361 38.91 16.471 39.9529 16.1005 40.3617C15.9783 40.4954 15.9668 40.7017 16.07 40.866C16.0738 40.8737 16.0814 40.8813 16.0852 40.8889C16.1922 41.0456 16.3832 41.1105 16.5513 41.057C17.0784 40.8851 18.4382 40.4725 19.0723 40.6177C19.7178 40.7705 20.8408 41.7906 21.2648 42.1917C21.3985 42.3178 21.5895 42.3484 21.7385 42.2643C21.7652 42.249 21.792 42.2299 21.8187 42.2108H21.8111Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_20053_243278)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0702 65.6139C48.4001 65.5067 48.6094 65.1741 48.5931 64.8087C48.5482 63.6628 48.4992 60.7177 49.1134 59.5991C49.7926 58.3723 52.4574 56.749 53.3394 56.2341C53.6632 56.0449 53.8211 55.6385 53.6963 55.2668C53.6957 55.2607 53.6953 55.2577 53.6916 55.252C53.574 54.9162 53.2515 54.7044 52.9134 54.7116C51.8996 54.7362 48.9988 54.7453 47.912 54.0618C46.6994 53.3006 45.0775 50.3936 44.5755 49.458C44.4234 49.172 44.129 48.9907 43.8207 49.016C43.7108 49.0252 43.6029 49.0526 43.5032 49.0974C43.2216 49.2238 43.0526 49.5304 43.0614 49.8569C43.0871 50.9131 43.1107 54.1824 42.438 55.4116C41.8319 56.52 39.4466 57.8886 38.4707 58.4171C38.1512 58.5906 37.9873 58.9701 38.0782 59.3425C38.0802 59.3606 38.0883 59.3781 38.0904 59.3962C38.1864 59.7589 38.5099 60.0074 38.8648 60.0136C39.9821 60.0325 42.8325 60.1515 43.9409 60.8356C45.0585 61.5462 46.5097 64.1938 47.0435 65.2207C47.2119 65.5416 47.553 65.7269 47.891 65.6646C47.9542 65.6514 48.0171 65.6352 48.0766 65.6163L48.0702 65.6139Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20053_243278",
    x: 11.3423,
    y: 0.226562,
    width: 60.2109,
    height: 61.251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.65098 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20053_243278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20053_243278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_20053_243278",
    x: 0,
    y: 18.999,
    width: 38.8047,
    height: 39.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.65098 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20053_243278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20053_243278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_20053_243278",
    x: 22.0532,
    y: 33.0137,
    width: 47.6855,
    height: 48.6631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.65098 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20053_243278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20053_243278",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccentStars01);
export default __webpack_public_path__ + "static/media/Accent_Stars_01.137fe1d589e8e5679d5514ed8f585641.svg";
export { ForwardRef as ReactComponent };